/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService
 */

export const summarizeDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService',
  rpcName: 'summarizeDocument',
  auth: 'app',
  fingerprint: 'y5dSGsxJ4ID3si3QTHC1jOG_YhHGDAhu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDocumentSummaryRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService',
  rpcName: 'updateDocumentSummary',
  auth: 'app',
  fingerprint: 'd733uDUHY6NmMDOPktaPveG_YhHGDAhu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDocumentSummaryRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService',
  rpcName: 'getDocumentSummary',
  auth: 'app',
  fingerprint: 'WaVocfdWmpxmMDOPktaPveG_YhHGDAhu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitFeedbackRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService',
  rpcName: 'submitFeedback',
  auth: 'app',
  fingerprint: '5BZot_-WLENz1eCUkKZwiuG_YhHGDAhu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};